// extracted by mini-css-extract-plugin
export default {"tooltip":"cp-z","sharingV2":"dp-z","sharingIconsV2":"ep-z","links":"fp-z","link":"gp-z","facebookV2":"hp-z","twitterV2":"ip-z","pinterestV2":"jp-z"};